import React from 'react';
import { Container, Typography, Paper, Box, Grid, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import SchoolRounded from '@mui/icons-material/SchoolRounded';
import FlagRounded from '@mui/icons-material/FlagRounded';
import EmojiEventsRounded from '@mui/icons-material/EmojiEventsRounded';
import PsychologyRounded from '@mui/icons-material/PsychologyRounded';

const AboutUs: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
      <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h3" gutterBottom fontWeight="bold" color="primary">
          About Us
        </Typography>
        <Typography variant="body1" paragraph>
          StudyStride is dedicated to empowering students across Scotland to take control of their educational journey.
          Our mission is to provide a transparent, engaging, and supportive platform where learning outcomes are clear and progress is celebrated.
        </Typography>
        <Typography variant="body1" paragraph>
          We believe that every student deserves to know exactly where they stand and what steps to take next. By digitising the curriculum
          and making it interactive, we are bridging the gap between traditional learning and modern technology.
        </Typography>

        <Typography variant="h5" fontWeight="bold" sx={{ mt: 4, mb: 2 }} color="primary">
          Our mission
        </Typography>
        <Typography variant="body1" paragraph>
          To help every learner see their progress, set clear goals, and move forward with confidence—step by step.
        </Typography>

        <Typography variant="h5" fontWeight="bold" sx={{ mt: 4, mb: 2 }} color="primary">
          What we offer
        </Typography>
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <SchoolRounded sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">Curriculum alignment</Typography>
              <Typography variant="body2" color="text.secondary">
                Scottish curriculum outcomes mapped so students and parents know what’s next.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <FlagRounded sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">Progress tracking</Typography>
              <Typography variant="body2" color="text.secondary">
                Clear views of progress by subject and topic, with next steps and recommendations.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <EmojiEventsRounded sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">Achievements</Typography>
              <Typography variant="body2" color="text.secondary">
                Badges, points, and milestones to keep motivation high and celebrate effort.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ textAlign: 'center' }}>
              <PsychologyRounded sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
              <Typography variant="subtitle1" fontWeight="bold">Insights</Typography>
              <Typography variant="body2" color="text.secondary">
                Simple insights for parents and teachers to support learning where it matters most.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Typography variant="h5" fontWeight="bold" sx={{ mt: 4, mb: 2 }} color="primary">
          Who we’re for
        </Typography>
        <Typography variant="body1" paragraph>
          StudyStride is for students, parents, teachers, and tutors who want clarity on progress and next steps. We focus on the Scottish curriculum and are built to work in the classroom and at home.
        </Typography>

        <Box sx={{ mt: 5, textAlign: 'center' }}>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Questions or feedback? We’d love to hear from you.
          </Typography>
          <Button component={Link} to="/contact" variant="contained" size="large">
            Contact us
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default AboutUs;
